'use client'

import { useEffect, useState } from 'react'
import { useMediaQuery } from '@segway/core'
import { useThrottleFn } from 'ahooks'

import { BackTopIcon } from '@/components'

const Float = () => {
  const [showBackTop, setShowBackTop] = useState(false)
  const responsive = useMediaQuery()
  const handleBackTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const { run: handleScroll } = useThrottleFn(
    () => {
      if (document.documentElement.scrollTop > window.innerHeight / 2) {
        setShowBackTop(true)
      } else {
        setShowBackTop(false)
      }
    },
    { wait: 200 },
  )

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  return showBackTop ? (
    <div className="fixed bottom-[104px] right-[48px] z-10 flex flex-col gap-[20px] max-xl:bottom-[24px] max-xl:right-[16px]">
      <div
        className="flex h-[56px] w-[56px] cursor-pointer items-center justify-center rounded-full bg-[#F3F3F4] shadow-[0_4px_16px_0px_rgba(0,0,0,0.14)] max-xl:h-[40px] max-xl:w-[40px]"
        onClick={handleBackTop}>
        <BackTopIcon
          width={responsive && responsive.xl ? 32 : 28}
          height={responsive && responsive.xl ? 32 : 28}
        />
      </div>
    </div>
  ) : null
}

export default Float
